
export default {
  name: 'Tab',
  provide() {
    return {
      addTab: this.addTab,
      removeTab: this.removeTab,
    }
  },
  data() {
    return {
      tabs: [],
      activeTabIndex: 0,
    }
  },
  computed: {
    slotData() {
      return {
        activeTabIndex: this.activeTabIndex,
        tabs: this.tabs,
      }
    },
  },
  watch: {
    value(newValue) {
      this.findAndActivateTab(newValue)
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.value) {
        this.findAndActivateTab(this.value)
      } else if (this.tabs.length > 0) {
        this.activateTab(this.tabs[0])
      }
    })
  },
  methods: {
    findAndActivateTab(title) {
      const tab = this.tabs.find(tab => tab.title === title)
      if (tab) {
        this.activateTab(tab)
      }
    },
    activateTab(tab) {
      if (this.handleClick) {
        this.handleClick(tab)
      }
      this.deactivateTabs()
      tab.active = true
      this.activeTabIndex = this.tabs.findIndex(t => t.active)
      this.$emit('change', this.tabs, this.activeTabIndex)
    },
    deactivateTabs() {
      this.tabs.forEach(tab => {
        tab.active = false
      })
    },
    addTab(tab) {
      if (this.activeTab === tab.name) {
        tab.active = true
      }
      this.tabs.push(tab)
    },
    removeTab(tab) {
      const index = this.tabs.indexOf(tab)
      if (index > -1) {
        this.tabs.splice(index, 1)
      }
    },
  },
}
